import { useQuery, UseQueryOptions } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { assetStorageApi } from 'src/Services/API';
import { AssetStorageItemDto } from 'src/Services/API/generated';
import formatDirectoryPath from 'src/Utils/formatDirectoryPath';

const useFetchDocuments = (
  path: string,
  options?: UseQueryOptions<
    AssetStorageItemDto[],
    unknown,
    AssetStorageItemDto[],
    (string | undefined)[]
  >
) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-documents', assetId, path],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');

      path = formatDirectoryPath(path);

      return (await assetStorageApi.assetStorageControllerFindAll(assetId, path)).data;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    ...options,
    enabled: !!assetId && options?.enabled !== false,
  });
};

export default useFetchDocuments;
